export const ka = {
  brandName: "TrendHome",
  home: {
    hero: {
      badge: "ტოპ რეიტინგული ტექნიკა",
      title: "ყველაფერი რაც",
      titleHighlight: "საახალწლოდ გჭირდება",
      description: "საუკეთესო ფასები, სწრაფი მიწოდება, უსაფრთხო გადახდა.",
      freeShipping: "სწრაფი მიწოდება",
      securePayment: "უსაფრთხო გადახდა",
      support24: "24/7 მხარდაჭერა",
      shopNow: "შეიძინე ახლა",
      exploreCategories: "კატეგორიების ნახვა",
      featuredProducts: "რეკომენდებული პროდუქტები",
      toolsForEveryday: "ნივთები ყოველდღიური გამოსაყენებლად",
      inStock: "მარაგშია",
      newInStock: "ახალი მარაგში",
      saveUpTo20: "დაზოგე 20%-მდე შეკვეთაზე",
      discountLabel: "შეზღუდული შეთავაზება",
      useCode: "არჩეულ სახლისა და ლაიფსტაილის პროდუქტებზე",
    },
    featured: {
      title: "რეკომენდებული პროდუქტები",
      description: "შერჩეული პროდუქტები, რომლებიც აკმაყოფილებენ ჩვენი ხარისხის სტანდარტებს",
      viewAll: "ყველა პროდუქტის ნახვა"
    },
    topRated: {
      title: "ყველაზე მაღალი რეიტინგის პროდუქტები",
      description: "მომხმარებლების რჩეული პროდუქტები",
      viewAll: "ყველა პროდუქტის ნახვა"
    },
    categories: {
      title: "შეძენა კატეგორიის მიხედვით",
      description: "დაათვალიერეთ ჩვენი ფართო არჩევანი პროდუქტების, რომლებიც კატეგორიების მიხედვითაა ორგანიზებული",
      exploreProducts: "პროდუქტების გაცნობა"
    }
  },
  navbar: {
    home: "მთავარი",
    products: "პროდუქტები",
    searchPlaceholder: "პროდუქტების ძიება...",
    cart: "კალათა",
    cartItems: "ნივთი",
    shoppingCart: "საყიდლების კალათა",
    signedInAs: "შესული ხართ როგორც",
    adminPanel: "ადმინ პანელი",
    myOrders: "ჩემი შეკვეთები",
    profile: "პროფილი",
    signOut: "გასვლა",
    signIn: "შესვლა",
    getStarted: "რეგისტრაცია",
    favourites: "რჩეულები",
    favouritesEmpty: "ჯერ არ დაგიმატებიათ რჩეულები",
    favouritesSignInPrompt: "შესვლის შემდეგ შეძლებთ რჩეული პროდუქტების შენახვას"
  },
  footer: {
    about: {
      description: "თქვენი საიმედო მიმართულება ხარისხიანი პროდუქტებისა და გამორჩეული სერვისისთვის.",
      qualityProducts: "ხარისხიანი პროდუქტები",
      fastDelivery: "სწრაფი მიწოდება",
      securePayment: "უსაფრთხო გადახდა",
      ourStory: "ჩვენი ისტორია",
      careers: "კარიერა",
      blog: "ბლოგი",
      partnerships: "პარტნიორობა"
    },
    customerService: {
      title: "მომხმარებლის სერვისი",
      helpCenter: "დახმარების ცენტრი / FAQ",
      shippingDelivery: "მიწოდება და გადაზიდვა",
      returnPolicy: "დაბრუნების პოლიტიკა",
      trackOrder: "შეკვეთის თვალყურის დევნება"
    },
    shopConfidence: {
      title: "იყიდეთ უსაფრთხოდ",
      secureCheckout: "უსაფრთხო გადახდა",
      sslEncryption: "SSL დაშიფვრა",
      paymentMethods: "გადახდის მეთოდები",
      warrantyPolicy: "გარანტიის პოლიტიკა",
      buyerProtection: "მყიდველის დაცვა"
    },
    contact: {
      title: "კონტაქტი და სიახლეები",
      phoneHours: "ორშ-პარ 9:00-18:00",
      support247: "24/7 მხარდაჭერა",
      stayUpdated: "დარჩით განახლებული",
      emailPlaceholder: "თქვენი ელფოსტა",
      subscribe: "გამოწერა"
    },
    bottom: {
      copyright: "© 2026 TrendHome. ყველა უფლება დაცულია.",
      privacyPolicy: "კონფიდენციალურობის პოლიტიკა",
      termsOfService: "მომსახურების პირობები",
      cookiePolicy: "Cookie პოლიტიკა",
      dataDeletion: "მონაცემების წაშლა"
    }
  },
  productDetail: {
    productNotFound: "პროდუქტი ვერ მოიძებნა",
    productNotFoundDesc: "პროდუქტი, რომელსაც ეძებთ, არ არსებობს.",
    inStock: "მარაგშია",
    outOfStock: "მარაგში არ არის",
    freeShipping: "სწრაფი მიწოდება",
    quantity: "რაოდენობა",
    addToCart: "კალათაში დამატება",
    buyNow: "ახლავე ყიდვა",
    productDetails: "პროდუქტის დეტალები",
    shippingReturns: "მიწოდება და დაბრუნება",
    description: "აღწერა",
    productSpecifications: "პროდუქტის მახასიათებლები",
    category: "კატეგორია",
    availability: "ხელმისაწვდომობა",
    stockAvailable: "მარაგში არის",
    units: "ერთეული",
    rating: "რეიტინგი",
    notRated: "არ არის შეფასებული",
    warranty: "გარანტია",
    included: "შედის",
    dimensions: "ზომები",
    color: "ფერი",
    material: "მასალა",
    notSpecified: "მითითებული არ არის",
    keyFeatures: "მთავარი მახასიათებლები",
    highQualityMaterials: "მაღალი ხარისხის მასალები",
    highQualityMaterialsDesc: "პრემიუმ კონსტრუქცია გამძლეობისთვის",
    durableConstruction: "გამძლე კონსტრუქცია",
    durableConstructionDesc: "შექმნილია გამძლეობისთვის მძლავრი დიზაინით",
    warrantyIncluded: "გარანტია შედის",
    warrantyIncludedDesc: "სრული დაცვა სიმშვიდისთვის",
    easyToMaintain: "ადვილი მოვლა",
    easyToMaintainDesc: "მარტივი მოვლა და გაწმენდის პროცესი",
    shippingInformation: "მიწოდების ინფორმაცია",
    freeShippingOver: "უფასო მიწოდება შეკვეთებზე",
    standardDelivery: "სტანდარტული მიწოდება:",
    expressDelivery: "ექსპრეს მიწოდება:",
    trackingNumber: "თრეკინგის ნომერი",
    trackingNumberDesc: "მოწოდებულია ყველა შეკვეთისთვის",
    returnPolicy: "დაბრუნების პოლიტიკა",
    dayReturnPolicy: "30-დღიანი დაბრუნების პოლიტიკა",
    dayReturnPolicyDesc: "გამოუყენებელი ნივთებისთვის",
    freeReturns: "უფასო დაბრუნება",
    freeReturnsDesc: "დეფექტური პროდუქტებისთვის",
    securePayment: "უსაფრთხო გადახდა",
    securePaymentDesc: "დაშიფვრით",
    customerSupport: "24/7 მომხმარებლის მხარდაჭერა",
    customerSupportDesc: "ხელმისაწვდომია",
    businessDays: "სამუშაო დღე",
    noImageAvailable: "სურათი არ არის ხელმისაწვდომი",
    generalInfo: "ზოგადი ინფო",
    reviewsTab: "მიმოხილვები",
    reviewsCountLabel: "მიმოხილვა",
    delivery: "მიწოდება",
    deliveryIntro: "უფასო სტანდარტული მიწოდება {amount}-ზე მეტ შეკვეთებზე, პლუს უფასო დაბრუნება.",
    colType: "ტიპი",
    colHowLong: "ვადა",
    colHowMuch: "ფასი",
    standardDeliveryName: "სტანდარტული მიწოდება",
    expressDeliveryName: "ექსპრეს მიწოდება",
    pickUpInStore: "მაღაზიიდან აღება",
    free: "უფასო",
    returnTitle: "დაბრუნება",
    returnIntro: "ნივთის დასაბრუნებლად გაქვთ {days} დღე, შემდეგი მეთოდებიდან ნებისმიერით:",
    returnMethodStore: "უფასო დაბრუნება მაღაზიაში",
    returnMethodCourier: "უფასო დაბრუნება კურიერით",
    favourite: "რჩეულებში დამატება",
    favouriteRemove: "რჩეულებიდან ამოშლა",
    addedToFavourites: "დაემატა რჩეულებში",
    removedFromFavourites: "ამოიშალა რჩეულებიდან",
    share: "გაზიარება",
    noReviewsTitle: "ჯერ არ არის მიმოხილვები",
    noReviewsDesc: "იყავი პირველი, ვინც გააზიარებს გამოცდილებას ამ პროდუქტზე.",
    similarItems: "მსგავსი ნივთები"
  },
  roomPreview: {
    button: "ნახე შენს ოთახში",
    title: "ნახე შენს ოთახში",
    subtitle: "ატვირთე შენი ოთახის ფოტო და ნახე, როგორ გამოიყურება {product} შენს სივრცეში.",
    close: "დახურვა",
    uploadCta: "ატვირთე ან გადაიღე ფოტო",
    uploadHint: "JPEG, PNG ან WebP, მაქსიმუმ 12 MB",
    changePhoto: "ფოტოს შეცვლა",
    placementLabel: "სად უნდა დადგეს? (არასავალდებულო)",
    placementPlaceholder: "მაგ. კუთხეში, ფანჯარასთან",
    chipCorner: "კუთხეში",
    chipByWindow: "ფანჯარასთან",
    chipCenter: "ცენტრში",
    chipAgainstWall: "კედელთან",
    remaining: "დღეს დარჩა {count} / {limit} გენერაცია",
    noneLeft: "დღევანდელი ლიმიტი ამოწურულია. გთხოვთ, დაბრუნდეთ ხვალ.",
    generate: "გენერირება",
    generating: "მიმდინარეობს გენერირება...",
    generatingHint: "ჩვეულებრივ სჭირდება 20-60 წამი. გთხოვთ, არ დახუროთ ეს ფანჯარა.",
    poweredBy: "AI-ს მიერ გენერირებული გამოსახულება - შედეგი მიახლოებითია.",
    before: "შენი ოთახი",
    after: "{product}-ით",
    download: "ჩამოტვირთვა",
    tryAnother: "სხვა ფოტოს ცდა",
    addToCart: "კალათაში დამატება",
    invalidFile: "გთხოვთ, აირჩიოთ JPEG, PNG ან WebP ფოტო.",
    fileTooLarge: "ფოტო ძალიან დიდია (მაქს. 12 MB).",
    errorGeneric: "მინახვის შექმნა ვერ მოხერხდა. სცადეთ სხვა ფოტო."
  },
  products: {
    filtering: "ფილტრაცია...",
    showingProducts: "ნაჩვენებია {start}-{end} {total} პროდუქტიდან",
    filters: "ფილტრები",
    searchProducts: "პროდუქტების ძიება",
    searchPlaceholder: "ძიება სახელით ან აღწერით...",
    category: "კატეგორია",
    allCategories: "ყველა კატეგორია",
    subcategory: "ქვეკატეგორია",
    allSubcategories: "ყველა ქვეკატეგორია",
    sortBy: "დალაგება",
    sortName: "სახელი ა-ჰ",
    sortPriceLow: "ფასი: დაბალი-მაღალი",
    sortPriceHigh: "ფასი: მაღალი-დაბალი",
    sortRating: "უმაღლესი რეიტინგი",
    priceRange: "ფასის დიაპაზონი",
    minimumRating: "მინიმალური რეიტინგი",
    anyRating: "ნებისმიერი რეიტინგი",
    stars: "{rating}+ ვარსკვლავი",
    inStockOnly: "მხოლოდ მარაგში",
    clearAllFilters: "გასუფთავება",
    gridView: "ბადის ხედი",
    listView: "სიის ხედი",
    noProductsFound: "პროდუქტები ვერ მოიძებნა",
    tryAdjustingFilters: "სცადეთ ფილტრების ან ძიების პარამეტრების შეცვლა",
    clearFilters: "ფილტრების გასუფთავება",
    previous: "წინა",
    next: "შემდეგი",
    lowStock: "დარჩა მხოლოდ {count}",
    outOfStock: "არ არის მარაგში"
  },
  cart: {
    title: "საყიდლების კალათა",
    subtitle: "გადაამოწმეთ თქვენი ნივთები და გადადით გადახდაზე",
    addedToCart: "დაემატა კალათაში",
    viewCart: "კალათის ნახვა",
    emptyTitle: "თქვენი კალათა ცარიელია",
    emptyDescription: "ჯერ არ დაემატა ნივთები თქვენს კალათაში.",
    continueShopping: "განაგრძეთ შოპინგი",
    item: "ნივთი",
    items: "ნივთი",
    quantity: "რაოდენობა",
    perItem: "ერთეულზე",
    total: "სულ",
    removeItem: "ნივთის წაშლა",
    onlyLeftInStock: "მხოლოდ {count} დარჩა მარაგში",
    addStockLimit: "ვერ დაემატა — მარაგშია მხოლოდ {count}",
    orderSummary: "შეკვეთის შეჯამება",
    promoCode: "პრომო კოდი",
    apply: "გამოყენება",
    subtotal: "ქვეჯამი ({count} ნივთი)",
    shipping: "მიწოდება",
    free: "უფასო",
    deliveryAtCheckout: "განსაზღვრდება გადახდისას",
    tax: "გადასახადი",
    proceedToCheckout: "გადადით გადახდაზე",
    freeShippingOver: "უფასო მიწოდება 50₾-ზე მეტ შეკვეთებზე",
    secureCheckout: "უსაფრთხო გადახდა SSL დაშიფვრით",
    returnPolicy: "30-დღიანი დაბრუნების პოლიტიკა"
  },
  auth: {
    signIn: "შესვლა",
    signInTitle: "შესვლა",
    signInSubtitle: "კეთილი იყოს თქვენი დაბრუნება",
    emailAddress: "ელფოსტა",
    emailPlaceholder: "თქვენი ელფოსტა",
    password: "პაროლი",
    passwordPlaceholder: "თქვენი პაროლი",
    rememberMe: "დამახსოვრება",
    forgotPassword: "დაგავიწყდათ პაროლი?",
    signingIn: "შესვლა...",
    orContinueWith: "ან გააგრძელეთ",
    continueWithGoogle: "გაგრძელება Google-ით",
    continueWithFacebook: "გაგრძელება Facebook-ით",
    dontHaveAccount: "არ გაქვთ ანგარიში?",
    createOneHere: "რეგისტრაცია",
    bySigningIn: "შესვლით თქვენ ეთანხმებით ჩვენს",
    termsOfService: "მომსახურების პირობებს",
    and: "და",
    privacyPolicy: "კონფიდენციალურობის პოლიტიკას",
    createAccount: "რეგისტრაცია",
    createAccountTitle: "რეგისტრაცია",
    createAccountSubtitle: "შემოგვიერთდით და დაიწყეთ შოპინგი დღესვე",
    username: "მომხმარებლის სახელი",
    usernamePlaceholder: "მომხმარებლის სახელი",
    firstName: "სახელი",
    firstNamePlaceholder: "თქვენი სახელი",
    lastName: "გვარი",
    lastNamePlaceholder: "თქვენი გვარი",
    emailOrPhone: "ელფოსტა ან ნომერი",
    emailOrPhonePlaceholder: "ელფოსტა ან ნომერი",
    createPassword: "პაროლი",
    confirmPassword: "გაიმეორე პაროლი",
    confirmPasswordPlaceholder: "გაიმეორე პაროლი",
    showPassword: "პაროლის ჩვენება",
    hidePassword: "პაროლის დამალვა",
    passwordMismatch: "პაროლები არ ემთხვევა",
    creatingAccount: "ანგარიშის შექმნა...",
    alreadyHaveAccount: "უკვე გაქვთ ანგარიში?",
    signInHere: "შესვლა",
    byCreatingAccount: "ანგარიშის შექმნით თქვენ ეთანხმებით ჩვენს",
    registrationFailed: "რეგისტრაცია ვერ მოხერხდა. გთხოვთ სცადოთ თავიდან.",
    loginFailed: "ელფოსტა/ნომერი ან პაროლი არასწორია",
    phone: "ტელეფონის ნომერი",
    phonePlaceholder: "5XX XX XX XX",
    emailOptional: "ელფოსტა (არასავალდებულო)",
    emailOptionalPlaceholder: "შეიყვანეთ ელფოსტა",
    sendCode: "კოდის გაგზავნა",
    sendingCode: "კოდი იგზავნება...",
    verificationCode: "დადასტურების კოდი",
    verificationCodePlaceholder: "6-ნიშნა კოდი",
    codeSentTo: "კოდი გამოგზავნილია ნომერზე",
    changeNumber: "ნომრის შეცვლა",
    resendCode: "კოდის ხელახლა გაგზავნა",
    resendIn: "ხელახლა {seconds} წმ-ში",
    verifyAndCreate: "დადასტურება და ანგარიშის შექმნა",
    verifying: "მოწმდება...",
    forgotPasswordTitle: "პაროლის აღდგენა",
    forgotPasswordSubtitle: "შეიყვანეთ ელფოსტა ან ტელეფონის ნომერი და გამოგიგზავნით კოდს",
    newPassword: "ახალი პაროლი",
    newPasswordPlaceholder: "შეიყვანეთ ახალი პაროლი",
    resetPasswordBtn: "პაროლის განახლება",
    resetting: "ნახლდება...",
    backToLogin: "შესვლაზე დაბრუნება",
    passwordResetSuccess: "პაროლი განახლდა. გთხოვთ შეხვიდეთ.",
    codeSentToast: "დადასტურების კოდი გაიგზავნა",
    mfaTitle: "ორეტაპიანი ვერიფიკაცია",
    mfaEnrollSubtitle: "დაამატეთ ტელეფონის ნომერი ადმინ ანგარიშის დასაცავად",
    mfaVerify: "დადასტურება და შესვლა"
  },
  profile: {
    title: "პროფილის პარამეტრები",
    subtitle: "მართეთ თქვენი ანგარიშის ინფორმაცია და პარამეტრები",
    notAuthenticated: "არ არის ავთენთიფიცირებული",
    pleaseLogIn: "გთხოვთ შეხვიდეთ პროფილის სანახავად.",
    personalInformation: "პირადი ინფორმაცია",
    edit: "რედაქტირება",
    username: "მომხმარებლის სახელი",
    firstName: "სახელი",
    lastName: "გვარი",
    emailAddress: "ელფოსტის მისამართი",
    phoneNumber: "ტელეფონის ნომერი",
    userId: "მომხმარებლის ID",
    accountActions: "ანგარიშის მოქმედებები",
    editProfile: "პროფილის რედაქტირება",
    securitySettings: "უსაფრთხოების პარამეტრები",
    accountStatus: "ანგარიშის სტატუსი",
    active: "აქტიური",
    signOut: "გასვლა",
    save: "ცვლილებების შენახვა",
    cancel: "გაუქმება",
    saving: "ინახება...",
    emailOrPhone: "ელფოსტა ან ტელეფონი",
    profileUpdated: "პროფილი წარმატებით განახლდა",
    updateFailed: "პროფილის განახლება ვერ მოხერხდა",
    fillRequired: "გთხოვთ შეავსოთ ყველა ველი",
    deliveryDetails: "მიწოდების ნაგულისხმევი დეტალები",
    deliveryDetailsHint: "ინახება აქ და ავტომატურად ივსება გადახდისას.",
    deliverySaved: "მიწოდების დეტალები შენახულია",
    deliverySaveFailed: "მიწოდების დეტალების შენახვა ვერ მოხერხდა",
    adminBadge: "ადმინისტრატორი",
    changePassword: "პაროლის შეცვლა",
    currentPassword: "მიმდინარე პაროლი",
    newPassword: "ახალი პაროლი",
    confirmPassword: "გაიმეორეთ ახალი პაროლი",
    updatePassword: "პაროლის განახლება",
    passwordChanged: "პაროლი წარმატებით შეიცვალა",
    passwordsDoNotMatch: "ახალი პაროლები არ ემთხვევა",
    passwordChangeFailed: "პაროლის შეცვლა ვერ მოხერხდა",
    socialLoginNoPassword: "Google-ით შექმნილი ანგარიშისთვის პაროლის შეცვლა მიუწვდომელია."
  },
  cookieConsent: {
    message: "ჩვენ ვიყენებთ Cookie-ებს საიტის გამართული მუშაობისა და თქვენი გამოცდილების გასაუმჯობესებლად. საიტის გამოყენების გაგრძელებით თქვენ ეთანხმებით ჩვენს",
    cookiePolicy: "Cookie პოლიტიკას",
    privacyPolicy: "კონფიდენციალურობის პოლიტიკას",
    terms: "მომსახურების პირობებს",
    accept: "ვეთანხმები",
    decline: "უარი"
  },
  shippingPage: {
    title: "მიწოდება და გადაზიდვა",
    intro: "მიწოდებას ახორციელებს ჩვენი პარტნიორი საკურიერო კომპანია, რომელიც უზრუნველყოფს შეკვეთის უსაფრთხო და დროულ მიტანას საქართველოს მასშტაბით.",
    sections: [
      {
        title: "მიწოდების პროცესი",
        text: "შეკვეთის დადასტურების შემდეგ, ნივთს მითითებულ მისამართზე მოგაწვდით ჩვენი პარტნიორი საკურიერო კომპანია."
      },
      {
        title: "მიწოდების ვადა",
        text: "მიწოდების დრო შეიძლება განსხვავდებოდეს მდებარეობისა და პროდუქტის ხელმისაწვდომობის მიხედვით."
      },
      {
        title: "მიწოდების ღირებულება",
        text: "მიწოდების საფასური გამოითვლება ადგილმდებარეობისა და შეფუთვის წონის მიხედვით და ემატება შეკვეთის ჯამურ თანხას გადახდისას."
      }
    ]
  },
  dataDeletion: {
    title: "მომხმარებლის მონაცემების წაშლა",
    intro: "ნებისმიერ დროს შეგიძლიათ მოითხოვოთ ჩვენს ხელთ არსებული თქვენი პერსონალური მონაცემების წაშლა. ამ გვერდზე აღწერილია, როგორ გააგზავნოთ მოთხოვნა და რა ხდება შემდეგ.",
    facebook: {
      title: "თუ Facebook-ით შედით",
      text: "თუ TrendHome-ს თქვენი Facebook-ის ანგარიშიდან წაშლით, ჩვენ ავტომატურად ვიგებთ ამის შესახებ — დამატებით დაკავშირება არ დაგჭირდებათ.",
      items: [
        "Facebook-ში გახსენით „პარამეტრები და კონფიდენციალურობა“, შემდეგ „პარამეტრები“.",
        "გადადით განყოფილებაში „აპლიკაციები და ვებსაიტები“.",
        "სიაში მოძებნეთ TrendHome და აირჩიეთ „წაშლა“.",
        "მონიშნეთ TrendHome-ის ხელთ არსებული მონაცემების წაშლის ველი და დაადასტურეთ."
      ],
      outro: "მოთხოვნის გაგზავნის შემდეგ Facebook გაჩვენებთ დადასტურების კოდს. შეიყვანეთ ის ქვემოთ, რომ ნებისმიერ დროს შეამოწმოთ წაშლის სტატუსი."
    },
    manual: {
      title: "ელფოსტით ან ტელეფონით",
      text: "თუ რეგისტრაცია ელფოსტით ან ტელეფონის ნომრით გაიარეთ, გამოგზავნეთ წაშლის მოთხოვნა თქვენს ანგარიშზე მითითებული ელფოსტიდან ან ნომრიდან. ჩვენ დავადასტურებთ, რომ ის მართლაც თქვენია, და წავშლით მონაცემებს.",
      items: [
        "ელფოსტა: contact@trendhome.ge",
        "ტელეფონი: +995 557 65 10 75"
      ]
    },
    status: {
      title: "მოთხოვნის სტატუსის შემოწმება",
      intro: "შეიყვანეთ მიღებული დადასტურების კოდი, რომ ნახოთ, რა ეტაპზეა თქვენი მოთხოვნა.",
      label: "დადასტურების კოდი",
      placeholder: "მაგ. 3f9c1a7b2e5d8c4a6b0f",
      submit: "სტატუსის შემოწმება",
      checking: "მიმდინარეობს შემოწმება...",
      codeLabel: "კოდი:",
      requestedAt: "მოთხოვნის თარიღი:",
      completedAt: "დასრულების თარიღი:",
      emptyCode: "პირველ რიგში შეიყვანეთ დადასტურების კოდი.",
      notFound: "ამ კოდით მოთხოვნა ვერ მოიძებნა. გადაამოწმეთ კოდი და სცადეთ ხელახლა.",
      error: "სტატუსის შემოწმება ამჟამად ვერ მოხერხდა. გთხოვთ, სცადოთ ცოტა ხანში.",
      result: {
        completed: "თქვენი მონაცემები წაშლილია.",
        no_data: "ამ ანგარიშზე ჩვენ არანაირი მონაცემი არ გვქონდა, ამიტომ წასაშლელი არაფერი იყო.",
        pending: "თქვენი მოთხოვნა მიღებულია და მუშავდება.",
        manual_review: "თქვენს მოთხოვნას ჩვენი გუნდი ხელით ამუშავებს. ის დასრულდება 30 დღის განმავლობაში.",
        failed: "მონაცემების წაშლისას მოხდა შეფერხება. ჩვენი გუნდი ინფორმირებულია და მოთხოვნას ხელით დაასრულებს."
      }
    },
    whatWeDelete: {
      title: "რას ვშლით",
      text: "მოთხოვნის დადასტურების შემდეგ ვშლით:",
      items: [
        "თქვენს ანგარიშსა და პროფილის მონაცემებს — სახელს, ელფოსტას, ტელეფონის ნომერს და შენახულ მიწოდების მისამართს.",
        "თქვენს კალათასა და რჩეულებს.",
        "ერთჯერად დადასტურების კოდებს, რომლებიც თქვენს ელფოსტასა თუ ნომერს უკავშირდება.",
        "კავშირს საიტზე თქვენი ნახვების ისტორიასა და ანგარიშს შორის."
      ]
    },
    whatWeKeep: {
      title: "რის შენახვა გვევალება",
      text: "დასრულებული შესყიდვების ჩანაწერები ინახება, რადგან ამას საქართველოს საგადასახადო და ბუღალტრული აღრიცხვის კანონმდებლობა მოითხოვს. ჩვენ მათგან ვშლით თქვენს სახელს, ელფოსტას, ტელეფონის ნომერსა და მიწოდების მისამართს, ამიტომ ისინი ვერ დაუკავშირდება თქვენს პიროვნებას."
    },
    timing: {
      title: "რამდენ ხანს იღებს",
      text: "Facebook-ის გზით მიღებული მოთხოვნები მუშავდება დაუყოვნებლივ. ელფოსტით ან ტელეფონით გამოგზავნილი მოთხოვნები სრულდება ვინაობის დადასტურებიდან 30 დღის განმავლობაში."
    }
  },
  privacy: {
    title: "კონფიდენციალურობის პოლიტიკა",
    lastUpdated: "ბოლოს განახლებული:",
    general: {
      title: "1. ზოგადი ინფორმაცია",
      text: "წინამდებარე კონფიდენციალურობის პოლიტიკა განსაზღვრავს, თუ როგორ აგროვებს, ამუშავებს, ინახავს და იცავს trendhome - ი (საიდენტიფიკაციო კოდი: 58001025443, იურიდიული მისამართი: გურამიშვილის გამზირი 62, თბილისი, საქართველო) (შემდგომში – „კომპანია“, „ჩვენ“) მომხმარებლის პერსონალურ მონაცემებს ვებგვერდის გამოყენებისას.",
      text2: "პერსონალური მონაცემების დამუშავება ხორციელდება საქართველოს მოქმედი კანონმდებლობის, მათ შორის „პერსონალურ მონაცემთა დაცვის შესახებ“ საქართველოს კანონის მოთხოვნების შესაბამისად."
    },
    dataWeCollect: {
      title: "2. რა პერსონალურ მონაცემებს ვაგროვებთ?",
      intro: "ვებგვერდის გამოყენებისას შესაძლებელია დამუშავდეს შემდეგი მონაცემები:",
      provided: {
        title: "2.1. მომხმარებლის მიერ მოწოდებული ინფორმაცია",
        items: [
          "სახელი და გვარი;",
          "ტელეფონის ნომერი;",
          "ელფოსტის მისამართი;",
          "მიწოდების მისამართი;",
          "ანგარიშის შექმნის შემთხვევაში – ანგარიშთან დაკავშირებული ინფორმაცია;",
          "შეკვეთასთან დაკავშირებული ინფორმაცია;",
          "თქვენ მიერ გამოგზავნილი შეტყობინებები ან მოთხოვნები."
        ]
      },
      technical: {
        title: "2.2. ავტომატურად შეგროვებული (ტექნიკური) ინფორმაცია",
        intro: "სისტემამ ავტომატურად შეიძლება დაამუშაოს:",
        items: [
          "IP მისამართი და მოწყობილობის ინფორმაცია;",
          "ოპერაციული სისტემა;",
          "ბრაუზერის ტიპი და ვერსია;",
          "ვიზიტის თარიღი და დრო;",
          "ნანახი გვერდები და ვებსაიტზე გატარებული დრო;",
          "რეფერალური ვებსაიტი ან წყარო;",
          "Cookie-ები და მსგავსი თრეკინგის ტექნოლოგიები."
        ]
      }
    },
    purposes: {
      title: "3. რა მიზნით ვამუშავებთ თქვენს მონაცემებს?",
      intro: "თქვენი პერსონალური მონაცემები შესაძლოა დამუშავდეს შემდეგი მიზნებისთვის:",
      orderFulfillment: {
        title: "3.1. შეკვეთების დამუშავება და შესრულება",
        text: "მომხმარებლის იდენტიფიკაცია, შეკვეთების მიღება, დამუშავება, გადაგზავნა, ნივთების მიწოდება და შემდგომი მომხმარებლის მხარდაჭერა."
      },
      accountManagement: {
        title: "3.2. ანგარიშის მართვა",
        text: "ანგარიშის შექმნა და მართვა (არსებობის შემთხვევაში), პარამეტრების შენახვა და პერსონალიზებული გამოცდილების მიწოდება."
      },
      communication: {
        title: "3.3. კომუნიკაცია",
        text: "მომხმარებელთან კავშირი, შეკვეთის განახლებების გაგზავნა, მომხმარებლის მოთხოვნებსა და შეტყობინებებზე პასუხის გაცემა."
      },
      security: {
        title: "3.4. ვებსაიტის გაუმჯობესება და უსაფრთხოება",
        text: "გამოყენების ნიმუშების ანალიზი, ვებგვერდისა და მომსახურების უსაფრთხოების უზრუნველყოფა, თაღლითობის, არასანქცირებული წვდომისა და სხვა სამართალდარღვევების პრევენცია."
      },
      marketing: {
        title: "3.5. მარკეტინგი (სარეკლამო შეთავაზებები)",
        text: "სარეკლამო შეთავაზებებისა და სიახლეების გაგზავნა მხოლოდ თქვენი წინასწარი თანხმობის საფუძველზე."
      }
    },
    legalBasis: {
      title: "4. მონაცემთა დამუშავების სამართლებრივი საფუძველი",
      intro: "პერსონალური მონაცემები მუშავდება მხოლოდ შესაბამისი სამართლებრივი საფუძვლის არსებობის შემთხვევაში, მათ შორის:",
      items: [
        "თქვენი თანხმობის საფუძველზე;",
        "თქვენთან დადებული ან დასადები ხელშეკრულების შესრულების მიზნით;",
        "კომპანიისთვის დაკისრებული სამართლებრივი ვალდებულების შესასრულებლად;",
        "კომპანიის ლეგიტიმური ინტერესის საფუძველზე, იმ პირობით, რომ არ ილახება თქვენი უფლებები და თავისუფლებები."
      ]
    },
    sharing: {
      title: "5. ვის შეიძლება გადაეცეს მონაცემები?",
      intro: "თქვენი პერსონალური მონაცემები არ იყიდება, არ იცვლება და არ გადაეცემა მესამე პირებს კომერციული მიზნებისთვის. მხოლოდ აუცილებლობის შემთხვევაში, მონაცემები შეიძლება გადაეცეს:",
      serviceProviders: {
        title: "5.1. სერვისის მომწოდებლები",
        items: [
          "ონლაინ გადახდის მომსახურების პროვაიდერებს (ბანკებს);",
          "საკურიერო კომპანიებს (შეკვეთის მისაწოდებლად);",
          "IT ინფრასტრუქტურისა და ჰოსტინგის მომსახურების მომწოდებლებს."
        ]
      },
      legalAndGovernment: {
        title: "5.2. იურიდიული და სახელმწიფო მოთხოვნები",
        items: [
          "ბუღალტრული ან იურიდიული მომსახურების მომწოდებლებს;",
          "სახელმწიფო ორგანოებს, როდესაც ამის ვალდებულება პირდაპირ კანონით არის განსაზღვრული (სასამართლო გადაწყვეტილება, საგადასახადო მოთხოვნა და სხვა)."
        ]
      },
      note: "შენიშვნა: ყველა აღნიშნული პირი ვალდებულია უზრუნველყოს მიღებული მონაცემების კონფიდენციალურობა და უსაფრთხოება."
    },
    retention: {
      title: "6. რამდენ ხანს ვინახავთ მონაცემებს?",
      intro: "პერსონალური მონაცემები ინახება მხოლოდ იმ ვადით, რომელიც აუცილებელია:",
      items: [
        "დამუშავების მიზნის მისაღწევად;",
        "კანონით გათვალისწინებული (მათ შორის საგადასახადო) ვალდებულებების შესასრულებლად;",
        "შესაძლო სამართლებრივი დავების გადაწყვეტისთვის."
      ],
      outro: "აღნიშნული ვადის გასვლის შემდეგ მონაცემები იშლება ან ხდება ანონიმური (ისე, რომ აღარ მოხდეს პირის იდენტიფიცირება)."
    },
    security: {
      title: "7. როგორ ვიცავთ თქვენს მონაცემებს?",
      intro: "კომპანია იყენებს შესაბამის ტექნიკურ და ორგანიზაციულ უსაფრთხოების ზომებს პერსონალური მონაცემების დასაცავად, მათ შორის:",
      measures: {
        title: "7.1. უსაფრთხოების ძირითადი ზომები",
        items: [
          "დაშიფრული კავშირის (SSL/TLS პროტოკოლის) გამოყენება მონაცემთა გადაცემისას;",
          "წვდომის კონტროლის სისტემები და აუტენტიფიკაციის მექანიზმები;",
          "უსაფრთხო გადახდების დამუშავება შესაბამისი და სერტიფიცირებული მომწოდებლების მეშვეობით;",
          "პერსონალურ მონაცემებზე წვდომის შეზღუდვა მხოლოდ იმ თანამშრომლებისთვის, ვისაც ეს პირდაპირ სამუშაოდ სჭირდება."
        ]
      },
      statement: "უსაფრთხოების განაცხადი: მიუხედავად ჩვენ მიერ მიღებული ყველა გონივრული ზომისა, ინტერნეტით მონაცემთა გადაცემის 100%-იან სრულ უსაფრთხოებას ვერცერთი სისტემა ვერ უზრუნველყოფს. მომხმარებელი აცნობიერებს ინტერნეტის საშუალებით მონაცემთა გაცვლასთან დაკავშირებულ ბუნებრივ რისკებს."
    },
    rights: {
      title: "8. თქვენი უფლებები და არჩევანი",
      intro: "მოქმედი კანონმდებლობის შესაბამისად, თქვენ გაქვთ უფლება:",
      access: {
        title: "8.1. წვდომა და განახლება",
        text: "მიიღოთ ინფორმაცია თქვენი პერსონალური მონაცემების დამუშავების შესახებ, მოითხოვოთ მათი ასლი, გასწორება ან განახლება."
      },
      marketing: {
        title: "8.2. მარკეტინგული კომუნიკაციები",
        text: "ნებისმიერ დროს უარი თქვათ მარკეტინგულ შეტყობინებებზე შესაბამისი გამოწერის გაუქმების ბმულზე დაჭერით."
      },
      deletion: {
        title: "8.3. მონაცემთა წაშლა და დამუშავების შეზღუდვა",
        text: "მოითხოვოთ მონაცემების წაშლა („დავიწყების უფლება“) ან მონაცემთა დამუშავების შეზღუდვა, გარდა იმ შემთხვევებისა, როდესაც მონაცემთა შენახვა სავალდებულოა კანონით ან აუცილებელია ხელშეკრულების შესასრულებლად."
      },
      withdraw: {
        title: "8.4. თანხმობის გამოხმობა და საჩივარი",
        text: "ნებისმიერ დროს გამოიხმოთ თქვენ მიერ გაცემული თანხმობა და მიმართოთ პერსონალურ მონაცემთა დაცვის სამსახურს, თუ მიიჩნევთ, რომ თქვენი უფლებები დაირღვა."
      }
    },
    cookies: {
      title: "9. მესამე მხარის მომსახურებები და Cookie-ები",
      text: "ვებგვერდი იყენებს Cookie-ებსა და მსგავს ტექნოლოგიებს ვებსაიტის მუშაობის გაუმჯობესების, მომხმარებელთა ქცევის ანალიზისა და მარკეტინგული მიზნებისთვის.",
      text2: "თქვენ შეგიძლიათ გააკონტროლოთ ან გამორთოთ Cookie-ების პარამეტრები თქვენი ბრაუზერის მეშვეობით. დამატებითი ინფორმაციისთვის გაეცანით ვებგვერდზე არსებულ Cookie პოლიტიკას."
    },
    changes: {
      title: "10. ცვლილებები კონფიდენციალურობის პოლიტიკაში",
      text: "ჩვენ უფლებამოსილი ვართ პერიოდულად განვაახლოთ წინამდებარე პოლიტიკა კანონმდებლობის ან ტექნოლოგიური პროცესების ცვლილების შესაბამისად. განახლებული ვერსია გამოქვეყნდება ვებგვერდზე და ძალაში შევა გამოქვეყნებისთანავე.",
      text2: "ჩვენი სერვისების გამოყენების გაგრძელება ცვლილებების გამოქვეყნების შემდეგ ნიშნავს განახლებული პოლიტიკის პირობებზე თანხმობას."
    },
    contactInfo: {
      title: "11. საკონტაქტო ინფორმაცია",
      intro: "პერსონალურ მონაცემებთან დაკავშირებულ ნებისმიერ საკითხზე ან თქვენი უფლებების გამოსაყენებლად შეგიძლიათ დაგვიკავშირდეთ:",
      items: [
        "კომპანია: მცირე მეწარმე (trendhome.ge)",
        "საიდენტიფიკაციო კოდი: 58001025443",
        "იურიდიული მისამართი: გურამიშვილის გამზირი 62, თბილისი, საქართველო",
        "ელფოსტა: contact@trendhome.ge",
        "ტელეფონი: +995 557 65 10 75"
      ]
    }
  },
  terms: {
    title: "მომსახურების პირობები",
    lastUpdated: "ბოლოს განახლებული:",
    introduction: {
      title: "1. შესავალი",
      text: "კეთილი იყოს თქვენი მობრძანება ჩვენს ელექტრონული კომერციის პლატფორმაზე. ეს მომსახურების პირობები (\"პირობები\") არეგულირებს ჩვენი ვებსაიტის, მობილური აპლიკაციებისა და სერვისების გამოყენებას. პლატფორმაზე წვდომით ან გამოყენებით, თქვენ ეთანხმებით ამ პირობებსა და ყველა გამოყენებად კანონსა და რეგულაციას."
    },
    acceptance: {
      title: "2. პირობების მიღება",
      text: "ანგარიშის შექმნით, შესყიდვის გაკეთებით ან ჩვენი სერვისების გამოყენებით, თქვენ აღიარებთ, რომ წაიკითხეთ, გაიგეთ და ეთანხმებით ამ მომსახურების პირობებს. ეს პირობები ვრცელდება ჩვენი პლატფორმის ყველა მომხმარებელზე."
    },
    accountRegistration: {
      title: "3. ანგარიშის რეგისტრაცია და უსაფრთხოება",
      accountCreation: {
        title: "3.1. ანგარიშის შექმნა",
        text: "თქვენ უნდა მოგვაწოდოთ ზუსტი და სრული ინფორმაცია ანგარიშის შექმნისას. თქვენ პასუხისმგებელი ხართ თქვენი ანგარიშის მონაცემების კონფიდენციალურობის შენარჩუნებაზე."
      },
      accountSecurity: {
        title: "3.2. ანგარიშის უსაფრთხოება",
        text: "თქვენ პასუხისმგებელი ხართ ყველა აქტივობაზე, რომელიც ხდება თქვენი ანგარიშის ქვეშ. დაუყოვნებლივ შეგვატყობინეთ ნებისმიერ არაავტორიზებულ გამოყენებაზე ან უსაფრთხოების დარღვევაზე."
      },
      ageRequirements: {
        title: "3.3. ასაკობრივი მოთხოვნები",
        text: "თქვენ უნდა იყოთ მინიმუმ 18 წლის ანგარიშის შესაქმნელად და შესყიდვების გასაკეთებლად."
      }
    },
    productsAndServices: {
      title: "4. პროდუქტები და სერვისები",
      productDescriptions: {
        title: "4.1. პროდუქტის აღწერები",
        text: "ჩვენ ვცდილობთ მოგაწოდოთ პროდუქტის ზუსტი აღწერები, სურათები და ფასები."
      },
      pricing: {
        title: "4.2. ფასები",
        text: "ყველა ფასი შეიძლება შეიცვალოს წინასწარი შეტყობინების გარეშე. ჩვენ ვიტოვებთ უფლებას შევცვალოთ ან შევწყვიტოთ პროდუქტები ნებისმიერ დროს."
      },
      availability: {
        title: "4.3. ხელმისაწვდომობა",
        text: "პროდუქტის ხელმისაწვდომობა არ არის გარანტირებული. ჩვენ ვიტოვებთ უფლებას შევზღუდოთ რაოდენობა და უარი ვთქვათ სერვისზე ნებისმიერისთვის."
      },
      thirdPartyProducts: {
        title: "4.4. მესამე მხარის პროდუქტები",
        text: "ზოგიერთი პროდუქტი შეიძლება გაიყიდოს მესამე მხარის გამყიდველების მიერ. ჩვენ არ ვართ პასუხისმგებელი მესამე მხარის პროდუქტის ხარისხზე ან შესრულებაზე."
      }
    },
    paymentTerms: {
      title: "5. გადახდის პირობები",
      paymentMethods: {
        title: "5.1. გადახდის მეთოდები",
        intro: "ჩვენ ვიღებთ სხვადასხვა გადახდის მეთოდებს, მათ შორის საკრედიტო ბარათები, სადებეტო ბარათები და ციფრული საფულეები. ყველა გადახდა დამუშავებულია უსაფრთხოდ ჩვენი გადახდის პარტნიორების მეშვეობით.",
        items: [
          "გადახდა საჭიროა შეკვეთის განთავსების დროს",
          "ჩვენ ვიტოვებთ უფლებას უარი ვთქვათ ან გავაუქმოთ შეკვეთები საეჭვო გადახდის აქტივობით",
          "ფასები არის ჩვენს ვებსაიტზე მითითებულ ვალუტაში",
          "გაყიდვის გადასახადი და მიწოდების საფასური დაემატება შესაბამისად"
        ]
      }
    },
    shipping: {
      title: "6. მიწოდება და გადაზიდვა",
      shippingPolicies: {
        title: "6.1. მიწოდების პოლიტიკა",
        items: [
          "მიწოდების დრო შეიძლება განსხვავდებოდეს მდებარეობისა და პროდუქტის ხელმისაწვდომობის მიხედვით",
          "მიწოდების ხარჯები გამოითვლება ადგილმდებარეობისა და შეფუთვის წონის მიხედვით"
        ]
      }
    },
    returns: {
      title: "7. დაბრუნება და თანხის დაბრუნება",
      returnPolicy: {
        title: "7.1. დაბრუნების პოლიტიკა",
        intro: "ნივთის დაბრუნება ხდება მიწოდებიდან 7 დღის განმავლობაში შემდეგი პირობების შესაბამისად:",
        items: [
          "ნივთები უნდა იყოს დაზიანებულ მდგომარეობაში და ჰქონდეს ხარვეზი",
          "ნივთი არ შეესაბამება შესყიდულ პროდუქტს",
          "დაბრუნების მიწოდების ხარჯები არის მომხმარებლის პასუხისმგებლობა, თუ ნივთი არ არის დეფექტური",
          "თანხის დაბრუნება დამუშავდება დაბრუნებული ნივთის მიღებიდან 14 სამუშაო დღის განმავლობაში"
        ]
      }
    },
    intellectualProperty: {
      title: "8. ინტელექტუალური საკუთრება",
      intro: "ჩვენი ვებსაიტი და მისი კონტენტი, მათ შორის ტექსტი, გრაფიკა, ლოგოები, სურათები და პროგრამული უზრუნველყოფა, არის ჩვენი კომპანიის საკუთრება და დაცულია საავტორო უფლებით, სავაჭრო ნიშნითა და სხვა ინტელექტუალური საკუთრების კანონებით.",
      text: "თქვენ არ შეგიძლიათ გაამრავლოთ, გაავრცელოთ, შეცვალოთ ან შექმნათ წარმოებული ნამუშევრები ჩვენი კონტენტიდან ჩვენი გამოხატული წერილობითი თანხმობის გარეშე. ყველა სავაჭრო ნიშანი და სავაჭრო სახელი არის შესაბამისი მფლობელების საკუთრება."
    },
    indemnification: {
      title: "9. ანაზღაურება",
      text: "თქვენ ეთანხმებით, რომ დაიცავთ, დაიცავთ და გაათავისუფლებთ ჩვენს კომპანიასა და მის ოფიცრებს, დირექტორებს, თანამშრომლებსა და აგენტებს ნებისმიერი მოთხოვნისგან, ზიანისგან, ვალდებულებებისგან, ზარალისგან, პასუხისმგებლობისგან, ხარჯებისგან ან ვალისგან, რომელიც წარმოიქმნება ჩვენი სერვისების გამოყენებით ან ამ პირობების დარღვევით."
    },
    governingLaw: {
      title: "10. მმართველი კანონი",
      text: "ეს პირობები უნდა იყოს გადაწყვეტილი და განმარტებული იმ იურისდიქციის კანონების შესაბამისად, სადაც რეგისტრირებულია ჩვენი კომპანია, მისი კონფლიქტის კანონის დებულებების გათვალისწინების გარეშე. ამ პირობებიდან ან ჩვენი სერვისების გამოყენებიდან წარმოშობილი ნებისმიერი დავა უნდა გადაწყვეტილ იქნას იმ იურისდიქციის სასამართლოებში."
    },
    changes: {
      title: "11. პირობების ცვლილებები",
      text: "ჩვენ ვიტოვებთ უფლებას შევცვალოთ ეს პირობები ნებისმიერ დროს. ჩვენ შევატყობინებთ მომხმარებლებს ნებისმიერ მნიშვნელოვან ცვლილებაზე განახლებული პირობების ვებსაიტზე განთავსებით და \"ბოლოს განახლებული\" თარიღის განახლებით. ჩვენი სერვისების გამოყენების გაგრძელება ასეთი ცვლილებების შემდეგ ნიშნავს განახლებული პირობების მიღებას."
    },
    contact: {
      title: "საკონტაქტო ინფორმაცია",
      intro: "თუ თქვენ გაქვთ შეკითხვები ამ მომსახურების პირობების შესახებ, გთხოვთ დაგვიკავშირდეთ:",
      email: "ელფოსტა:",
      phone: "ტელეფონი:",
      address: "მისამართი:"
    }
  },
  cookies: {
    title: "Cookie პოლიტიკა",
    lastUpdated: "ბოლოს განახლებული:",
    general: {
      title: "1. ზოგადი ინფორმაცია",
      text: "წინამდებარე Cookie პოლიტიკა განმარტავს, თუ როგორ იყენებს trendhome - ი (საიდენტიფიკაციო კოდი: 58001025443, იურიდიული მისამართი: გურამიშვილის გამზირი 62, თბილისი, საქართველო) (შემდგომში – „კომპანია“, „ჩვენ“) Cookie-ებსა და მსგავს ტექნოლოგიებს თავის ვებგვერდზე.",
      text2: "ვებგვერდის გამოყენებით თქვენ ეთანხმებით Cookie-ების გამოყენებას წინამდებარე პოლიტიკის შესაბამისად. თქვენი არჩევანის შეცვლა ნებისმიერ დროს შეგიძლიათ ბრაუზერის პარამეტრებით ან თანხმობის ბანერით."
    },
    whatAreCookies: {
      title: "2. რა არის Cookie-ები?",
      text: "Cookie-ები არის მცირე ზომის ტექსტური ფაილები, რომლებიც ინახება თქვენს მოწყობილობაზე (კომპიუტერი, ტაბლეტი ან ტელეფონი) ვებგვერდზე ვიზიტისას. ისინი ეხმარება ვებგვერდს გამართულ მუშაობაში, ინახავს თქვენს პარამეტრებს და აუმჯობესებს გამოყენების გამოცდილებას.",
      text2: "მსგავსი ტექნოლოგიები (მაგ. local storage და პიქსელები) შესაძლოა იმავე მიზნით გამოიყენებოდეს; წინამდებარე პოლიტიკაში ისინი ერთობლივად მოხსენიებულია როგორც „Cookie-ები“."
    },
    types: {
      title: "3. რა ტიპის Cookie-ებს ვიყენებთ?",
      intro: "დანიშნულების მიხედვით, ვიყენებთ Cookie-ების შემდეგ კატეგორიებს:",
      essential: {
        title: "3.1. აუცილებელი (ტექნიკური) Cookie-ები",
        text: "საჭიროა ვებგვერდის გამართული მუშაობისთვის – მაგალითად, კალათაში ნივთების შენახვა, სესიის შენარჩუნება და უსაფრთხოების უზრუნველყოფა. მათი გამორთვა შეუძლებელია."
      },
      performance: {
        title: "3.2. ანალიტიკური / შესრულების Cookie-ები",
        text: "გვეხმარება გავიგოთ, როგორ იყენებენ მომხმარებლები ვებგვერდს (ნანახი გვერდები, გატარებული დრო, შეცდომები), რათა გავზომოთ და გავაუმჯობესოთ მისი მუშაობა."
      },
      functional: {
        title: "3.3. ფუნქციური Cookie-ები",
        text: "ინახავს თქვენს არჩევანს (მაგ. ენა და პარამეტრები) გაუმჯობესებული, პერსონალიზებული ფუნქციონალის უზრუნველსაყოფად."
      },
      marketing: {
        title: "3.4. მარკეტინგული (სამიზნე) Cookie-ები",
        text: "შესაძლოა დაყენდეს ჩვენ ან ჩვენი პარტნიორების მიერ, რათა გაჩვენოთ შესაბამისი შეთავაზებები და გავზომოთ რეკლამის ეფექტურობა. გამოიყენება მხოლოდ თქვენი თანხმობით."
      }
    },
    thirdParty: {
      title: "4. მესამე მხარის Cookie-ები",
      text: "ზოგიერთი Cookie შესაძლოა დაყენდეს მესამე მხარის მომსახურების მომწოდებლების მიერ (მაგალითად, გადახდის სისტემები, ანალიტიკა ან სოციალური ქსელები), რომელთა მიერ მონაცემების გამოყენება რეგულირდება მათივე კონფიდენციალურობის პოლიტიკით.",
      text2: "კომპანია არ აკონტროლებს მესამე მხარის Cookie-ებს და გირჩევთ გაეცნოთ შესაბამისი მომწოდებლების პოლიტიკებს."
    },
    managing: {
      title: "5. Cookie-ების მართვა და კონტროლი",
      intro: "თქვენ სრულად აკონტროლებთ Cookie-ებს:",
      browser: {
        title: "5.1. ბრაუზერის პარამეტრები",
        text: "Cookie-ების მიღება, დაბლოკვა ან წაშლა შეგიძლიათ ბრაუზერის პარამეტრებით. Cookie-ების გამორთვის შემთხვევაში ვებგვერდის ზოგიერთმა ნაწილმა შესაძლოა გამართულად ვერ იმუშაოს."
      },
      consent: {
        title: "5.2. თანხმობის ბანერი",
        text: "ვებგვერდზე პირველი ვიზიტისას შეგიძლიათ მიიღოთ ან მოირგოთ Cookie-ების კატეგორიები თანხმობის ბანერის მეშვეობით და ნებისმიერ დროს შეცვალოთ არჩევანი."
      }
    },
    retention: {
      title: "6. Cookie-ების შენახვის ვადა",
      text: "Cookie-ები ინახება სხვადასხვა ვადით მათი ტიპის მიხედვით: სესიური Cookie-ები იშლება ბრაუზერის დახურვისთანავე, ხოლო მუდმივი Cookie-ები რჩება განსაზღვრული ვადით ან სანამ თავად არ წაშლით მათ."
    },
    changes: {
      title: "7. ცვლილებები Cookie პოლიტიკაში",
      text: "ჩვენ შესაძლოა პერიოდულად განვაახლოთ წინამდებარე Cookie პოლიტიკა კანონმდებლობის, ტექნოლოგიების ან ჩვენი პრაქტიკის ცვლილების შესაბამისად. განახლებული ვერსია გამოქვეყნდება ვებგვერდზე და ძალაში შევა გამოქვეყნებისთანავე.",
      text2: "ჩვენი სერვისების გამოყენების გაგრძელება ცვლილებების გამოქვეყნების შემდეგ ნიშნავს განახლებული პოლიტიკის პირობებზე თანხმობას."
    },
    contactInfo: {
      title: "8. საკონტაქტო ინფორმაცია",
      intro: "Cookie-ების გამოყენებასთან ან წინამდებარე პოლიტიკასთან დაკავშირებულ ნებისმიერ საკითხზე შეგიძლიათ დაგვიკავშირდეთ:",
      items: [
        "კომპანია: მცირე მეწარმე (trendhome.ge)",
        "საიდენტიფიკაციო კოდი: 58001025443",
        "იურიდიული მისამართი: გურამიშვილის გამზირი 62, თბილისი, საქართველო",
        "ელფოსტა: contact@trendhome.ge",
        "ტელეფონი: +995 557 65 10 75"
      ]
    }
  },
  checkout: {
    backToCart: "კალათაში დაბრუნება",
    title: "გადახდა",
    subtitle: "დაასრულეთ შეძენა",
    item: "ნივთი",
    items: "ნივთი",
    emptyTitle: "გასახდელი ნივთები არ არის",
    emptyDescription: "თქვენი კალათა ცარიელია. დაამატეთ ნივთები გასაგრძელებლად.",
    continueShopping: "შოპინგის გაგრძელება",
    shippingInfo: "მიწოდების ინფორმაცია",
    firstName: "სახელი",
    lastName: "გვარი",
    email: "ელ. ფოსტა",
    address: "მისამართი",
    addressPlaceholder: "მაგ. რუსთაველის გამზ. 12",
    city: "ქალაქი",
    phone: "ტელეფონის ნომერი",
    phonePlaceholder: "მაგ. 599 12 34 56",
    deliveryZone: "მიწოდების ზონა",
    zoneTbilisi: "თბილისი",
    zoneRegion: "რეგიონი",
    fillAllFields: "გთხოვთ შეავსოთ მიწოდების ყველა ველი",
    saveDeliveryPrompt: "შევინახო ეს მიწოდების დეტალები მომავლისთვის?",
    verifyPhone: "დადასტურება",
    verifyPhoneHint: "შეკვეთის განსათავსებლად დაადასტურეთ ტელეფონის ნომერი.",
    phoneVerified: "დადასტურებულია",
    enterSmsCode: "შეიყვანეთ SMS-ით გამოგზავნილი კოდი",
    confirmCode: "დადასტურება",
    sendingCode: "იგზავნება...",
    verifyingPhone: "მოწმდება...",
    phoneVerifiedToast: "ტელეფონის ნომერი დადასტურდა",
    verifyPhoneFirst: "ჯერ დაადასტურეთ ტელეფონის ნომერი",
    resendCode: "კოდის ხელახლა გაგზავნა",
    resendIn: "ხელახლა {seconds}წმ-ში",
    verifyPhoneModalTitle: "ტელეფონის ნომრის დადასტურება",
    verifyPhoneModalDesc: "გთხოვთ შეიყვანოთ 6-ნიშნა კოდი, რომელიც გამოგზავნილია ნომერზე {phone}, გადახდის გასაგრძელებლად.",
    orderSummary: "შეკვეთის შეჯამება",
    quantity: "რაოდ.",
    subtotal: "ჯამი",
    shipping: "მიწოდება",
    free: "უფასო",
    total: "სულ",
    includingTaxes: "ყველა გადასახადის ჩათვლით",
    secureCheckout: "უსაფრთხო გადახდა",
    freeShipping: "სწრაფი მიწოდება"
  },
  orders: {
    title: "ჩემი შეკვეთები",
    orderSingular: "შეკვეთა",
    orderPlural: "შეკვეთა",
    emptyTitle: "შეკვეთები ჯერ არ გაქვთ",
    emptyDescription: "დაიწყეთ შოპინგი, რომ აქ იხილოთ თქვენი შეკვეთები.",
    browseProducts: "პროდუქტების დათვალიერება",
    quantity: "რაოდ.",
    itemSingular: "ნივთი",
    itemPlural: "ნივთი",
    shippingAddress: "მიწოდების მისამართი",
    payment: "გადახდა",
    cashOnDelivery: "გადახდა მიწოდებისას",
    paymentMethod: {
      flitt: "ბარათით გადახდა",
      card: "ბარათით გადახდა",
      cod: "გადახდა მიწოდებისას"
    },
    months: [
      "იანვარი", "თებერვალი", "მარტი", "აპრილი", "მაისი", "ივნისი",
      "ივლისი", "აგვისტო", "სექტემბერი", "ოქტომბერი", "ნოემბერი", "დეკემბერი"
    ],
    status: {
      pending: "მოლოდინში",
      paid: "გადახდილია",
      confirmed: "გადახდილია",
      processing: "მუშავდება",
      shipped: "გაგზავნილი",
      delivered: "მიწოდებული",
      cancelled: "გაუქმებული"
    }
  },
  payment: {
    title: "გადახდა",
    cardTitle: "ბარათით გადახდა",
    cardDescription: "თქვენ უსაფრთხოდ გადამისამართდებით Flitt-ზე ბარათით გადახდის დასასრულებლად.",
    payButton: "გადახდა",
    processing: "მუშავდება...",
    redirecting: "გადამისამართება უსაფრთხო გადახდაზე...",
    failedToStart: "გადახდის დაწყება ვერ მოხერხდა",
    secureCheckout: "უსაფრთხო გადახდა",
    result: {
      verifyingTitle: "მიმდინარეობს გადახდის შემოწმება",
      verifyingDescription: "გთხოვთ დაელოდოთ, სანამ დავადასტურებთ თქვენს გადახდას.",
      successTitle: "გადახდა წარმატებულია!",
      successDescription: "გმადლობთ შეძენისთვის. თქვენი გადახდა მიღებულია.",
      pendingTitle: "გადახდა მუშავდება",
      pendingDescription: "თქვენი გადახდა მუშავდება. შეკვეთას განვაახლებთ დადასტურებისთანავე.",
      failedTitle: "გადახდა ვერ შესრულდა",
      failedDescription: "თქვენი გადახდის დასრულება ვერ მოხერხდა. გთხოვთ სცადოთ თავიდან.",
      orderNumber: "შეკვეთის ნომერი:",
      viewOrders: "ჩემი შეკვეთები",
      continueShopping: "შოპინგის გაგრძელება",
      tryAgain: "თავიდან ცდა",
      backToCart: "კალათაში დაბრუნება"
    }
  },
  // backend-ის (FastAPI/Pydantic) ვალიდაციისა და auth შეტყობინებების ქართული
  // ვერსიები, key — ზუსტი ინგლისური სტრინგი, რომელსაც API აბრუნებს.
  toasts: {
    loginSuccess: "წარმატებით შეხვედით",
    loginFailed: "შესვლა ვერ მოხერხდა",
    registerSuccess: "რეგისტრაცია წარმატებით დასრულდა!",
    logoutSuccess: "წარმატებით გამოხვედით",
    tokenRefreshFailed: "სესიის განახლება ვერ მოხერხდა",
    cartLoadFailed: "კალათის ჩატვირთვა ვერ მოხერხდა",
    cartLoginRequired: "კალათაში დასამატებლად გთხოვთ შეხვიდეთ",
    cartAddFailed: "პროდუქტის კალათაში დამატება ვერ მოხერხდა",
    cartUpdateSuccess: "კალათა განახლდა",
    cartUpdateFailed: "კალათის განახლება ვერ მოხერხდა",
    cartRemoveSuccess: "პროდუქტი კალათიდან წაიშალა",
    cartRemoveFailed: "პროდუქტის წაშლა ვერ მოხერხდა",
    wishlistLoginRequired: "რჩეულების გამოსაყენებლად გთხოვთ შეხვიდეთ",
    wishlistUpdateFailed: "რჩეულების განახლება ვერ მოხერხდა",
  },
  apiErrors: {
    "Email or phone is required": "ელფოსტა ან ნომერი სავალდებულოა",
    "Invalid email address": "ელფოსტის არასწორი ფორმატი",
    "Invalid phone number": "ტელეფონის არასწორი ნომერი",
    "Password must be at least 8 characters long": "პაროლი უნდა შეიცავდეს მინიმუმ 8 სიმბოლოს",
    "Password must be at most 72 bytes long": "პაროლი ძალიან გრძელია",
    "Password must contain both letters and numbers": "პაროლი უნდა შეიცავდეს ასოებსაც და ციფრებსაც",
    "Incorrect email or password": "ელფოსტა/ნომერი ან პაროლი არასწორია",
    "This email or phone is already registered": "ეს ელფოსტა ან ნომერი უკვე რეგისტრირებულია",
    "Current password is incorrect": "მიმდინარე პაროლი არასწორია",
    "Password change is not available for social login accounts": "Google-ით შესული ანგარიშისთვის პაროლის შეცვლა მიუწვდომელია",
    "This field is required": "ეს ველი სავალდებულოა",
    "Invalid code": "არასწორი კოდი",
    "This phone is already registered": "ეს ნომერი უკვე რეგისტრირებულია",
    "This email is already registered": "ეს ელფოსტა უკვე რეგისტრირებულია",
    "invalid_phone": "არასწორი ტელეფონის ნომერი",
    "phone_taken": "ეს ნომერი უკვე რეგისტრირებულია",
    "phone_not_verified": "შეკვეთის განთავსებამდე დაადასტურეთ ტელეფონის ნომერი",
    "otp_invalid": "კოდი არასწორია ან ვადაგასულია",
    "otp_cooldown": "ახალი კოდის მოთხოვნამდე გთხოვთ დაელოდოთ",
    "otp_too_many_attempts": "ძალიან ბევრი მცდელობა. მოითხოვეთ ახალი კოდი",
    "invalid_mfa": "სესია ამოიწურა. გთხოვთ თავიდან შეხვიდეთ",
    "Facebook login is not configured on the server": "Facebook-ით შესვლა სერვერზე არ არის კონფიგურირებული",
    "Invalid Facebook token": "Facebook-ით შესვლა ვერ მოხერხდა. გთხოვთ სცადოთ ხელახლა.",
    "Admin accounts must sign in with a password": "ადმინისტრატორის ანგარიშით შესვლა მხოლოდ პაროლით არის შესაძლებელი"
  } as Record<string, string>
};
